
class BESSAppRoomPassIndicator extends BESSAppComponent {

    constructor() {
        super('.room_pass_indicator');
    }

    setupComponent(componentNode) {
        componentNode.find('.app-consolidated-value').each(function(){
           let content = $(this).text();
           $(this).removeClass('pass').removeClass('fail');
           if(content.indexOf('Yes') !== -1) {
               $(this).addClass('pass');
           } else if(content.indexOf('No') !== -1) {
               $(this).addClass('fail');
           }
        });
    }
}